import types from '../actions/types';

const initialState = {
  steps: [],
  selectedStep: { pos: 0, global: 0, name: '' },
  innerPages: [],
};

const cleanableState = {
  prevStep: { pos: 0, global: 0, name: '' },
  stepInnerPage: {name: '', back: ''},

  showError: false,
  isInnerLoading: false,
  isLoading: false,
};

const steps = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      return { ...state, ...cleanableState, selectedStep: state.steps[0]};

    case types.SET_STEPS_LIST:
      return {
        ...state,
        steps: action.payload,
        selectedStep: action.payload[0]
      };

    case types.INCREASE_STEP:
      return {
        ...state,
        showError: false,
        prevStep: state.selectedStep,
        selectedStep: state.steps[state.selectedStep.pos + 1],
      };

    case types.DECREASE_STEP:
      if (state.stepInnerPage.back !== '') {
        return {
          ...state,
          showError: false,
          stepInnerPage: state.innerPages.find(page => page.name === state.stepInnerPage.back),
        };
      }
      return {
        ...state,
        showError: false,
        prevStep: state.selectedStep,
        selectedStep: state.steps[state.selectedStep.pos - 1],
        stepInnerPage: {name: '', back: ''},
      };

    case types.SET_INNER_PAGES_LIST:
      return {
        ...state,
        innerPages: action.payload,
        stepInnerPage: action.payload[0]
      };

    case types.SET_STEP_INNER_PAGE:
      return {
        ...state,
        showError: false,
        stepInnerPage: state.innerPages.find(page => page.name === action.payload),
      };

    case types.SHOW_ERROR:
      return {
        ...state,
        showError: action.payload,
      };

    case types.SHOW_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case types.SHOW_INNER_LOADING:
      return {
        ...state,
        isInnerLoading: action.payload,
      };

    default:
      return state;
  }
};

export default steps;
